function PocketIcon({ size = '19', style = {} }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2537 0.365883H2.92035C1.50368 0.365883 0.420349 1.44922 0.420349 2.86588V7.86588C0.420349 12.9492 4.50368 17.0326 9.58702 17.0326C14.6703 17.0326 18.7537 12.9492 18.7537 7.86588V2.86588C18.7537 1.44922 17.6703 0.365883 16.2537 0.365883ZM17.087 7.86588C17.087 12.0325 13.7537 15.3659 9.58702 15.3659C5.42035 15.3659 2.08702 12.0325 2.08702 7.86588V2.86588C2.08702 2.36588 2.42035 2.03255 2.92035 2.03255H16.2537C16.7537 2.03255 17.087 2.36588 17.087 2.86588V7.86588ZM13.5037 7.61588C13.837 7.28255 13.837 6.78255 13.5037 6.44922C13.1703 6.11588 12.6703 6.11588 12.337 6.44922L9.58702 9.19922L6.83702 6.44922C6.50368 6.11588 6.00368 6.11588 5.67035 6.44922C5.33702 6.78255 5.33702 7.28255 5.67035 7.61588L9.00368 10.9492C9.17035 11.1159 9.33702 11.1992 9.58702 11.1992C9.83702 11.1992 10.0037 11.1159 10.1703 10.9492L13.5037 7.61588Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="-8.74632"
          y1="8.69922"
          x2="7.84494"
          y2="26.9496"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A416F" />
          <stop offset="1" stopColor="#141727" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default PocketIcon;
